var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0125 7.99377V55.8688H12.0437V7.99377H52.0125ZM52.0125 3.99377H12.0437C9.83745 3.99377 8.0437 5.78752 8.0437 7.99377V55.8688C8.0437 58.075 9.83745 59.8688 12.0437 59.8688H52.0125C54.2187 59.8688 56.0125 58.075 56.0125 55.8688V7.99377C56.0125 5.78127 54.2187 3.99377 52.0125 3.99377Z",
    fill: "#DD9387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3372 26.0103V12.0541H30.2934V26.0103H16.3372Z",
    fill: "#DD9387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8149 51.5106V49.5106H51.9337V51.5106H45.8149Z",
    fill: "#8C98A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0125 59.8938H28.5125V48.8938C28.5125 46.6875 30.3062 44.8938 32.5125 44.8938H56.0125C58.2187 44.8938 60.0125 46.6875 60.0125 48.8938V55.8938C60.0125 58.1063 58.2187 59.8938 56.0125 59.8938Z",
    fill: "#C1756C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9749 48.1875C39.1249 48.1875 40.2124 49.1 40.2124 50.925C40.2124 52.7625 39.1249 53.6875 36.9499 53.6875H34.7374V57.1125H33.2749V48.1875H36.9749ZM34.7374 52.4375H36.8624C37.5124 52.4375 37.9874 52.3125 38.2874 52.0875C38.5874 51.85 38.7374 51.4625 38.7374 50.925C38.7374 50.3875 38.5749 50.0125 38.2749 49.7875C37.9749 49.55 37.4999 49.4375 36.8624 49.4375H34.7374V52.4375ZM45.1624 48.1875C47.3124 48.1875 48.3999 49.1 48.3999 50.925C48.3999 52.7625 47.3124 53.6875 45.1374 53.6875H42.9249V57.1125H41.4624V48.1875H45.1624ZM42.9249 52.4375H45.0499C45.6999 52.4375 46.1749 52.3125 46.4749 52.0875C46.7749 51.85 46.9249 51.4625 46.9249 50.925C46.9249 50.3875 46.7624 50.0125 46.4624 49.7875C46.1624 49.55 45.6874 49.4375 45.0499 49.4375H42.9249V52.4375ZM56.2749 48.1875V49.4375H53.3499V57.1125H51.8874V49.4375H48.9624V48.1875H56.2749Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7062 13.7375C26.2 13.7375 27.4625 14.7938 27.4625 16.9125C27.4625 19.0438 26.2 20.1188 23.675 20.1188H21.1063V24.0938H19.4062V13.7375H23.7062ZM21.1125 18.6688H23.5812C24.3375 18.6688 24.8875 18.525 25.2375 18.2625C25.5875 17.9875 25.7625 17.5375 25.7625 16.9125C25.7625 16.2875 25.575 15.8563 25.225 15.5938C24.875 15.3188 24.325 15.1875 23.5875 15.1875H21.1187V18.6688H21.1125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2938 33.45V25.6875C35.9125 25.6875 32.3625 29.2375 32.3625 33.6187C32.3625 38 35.9125 41.55 40.2938 41.55C44.675 41.55 48.225 38 48.225 33.6187V33.4562H40.2938V33.45Z",
    fill: "#DD9387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/ppt-icon.189bf2a83aaa8406531fbd1f29bf607a.svg";
export { ForwardRef as ReactComponent };